import React, { Component } from 'react'
import { 
  connectInfiniteHits
} from 'react-instantsearch-dom'
import { SearchIcon , CheckedIcon, EbookIcon, VideoIcon, ArticleIcon, PlayIcon, DownIcon, CloseIcon, PlaceholderImageMobile } from '../../icons'

class Hits extends Component {
  constructor(props){
    super(props)
  }

  render() {
    const { hits, hasPrevious, refinePrevious, hasMore, refineNext } = this.props
    const articleList = hits.map((article) => {
      return (
        <div className="column column-3 medium-12 margin-bottom-4x padding-bottom-3x visible " key={article.objectID}>
          <div className="article-block relative">
            <a className="content-overlay" href={`blogs/${article.blog.handle}/${article.handle}`}></a>
            <div className="background-image margin-bottom-3x relative" style={{backgroundImage: `url(${article.image})`}} >
              {article.iconType && article.iconType === `video` ?
                <div className="play-wrapper flex h-center v-center"><PlayIcon/></div>:
                null
              }

            </div>
            <div className="content padding-left-1x">
              <p className="inline wide margin-bottom-2x foreground-darkest-green">
                {article.named_tags.content_type && article.named_tags.content_type === `video` ?
                  <VideoIcon />:
                  null}
                {article.named_tags.content_type && article.named_tags.content_type === `article` ?
                  <ArticleIcon />:
                  null}
                {article.named_tags.content_type && article.named_tags.content_type === `ebook` ?
                  <EbookIcon />:
                  null}
                {article.named_tags.content_type ?
                  <span className="margin-left-1x text-uppercase left inline">{article.named_tags.content_type}</span>  :
                  null
                }
              </p>
              <h2 className="h2 heading">{article.title}</h2>
            </div>
          </div>
        </div>
      )
    })

    return (
      <React.Fragment>
        <div className="row margin-bottom-3x small-margin-0x">
          {articleList}
        </div>
        {hasMore ? (
          <div className="row flex h-center padding-top-3x padding-bottom-5x small-padding-top-4x small-margin-0x">
            <div className="column column-6 small-12 small-padding-0x text-center">
              <button className="button is-border is-small wide" onClick={refineNext}>
                Load more
              </button>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    )
  }
}

const ArticleHits = connectInfiniteHits(Hits)

export default ArticleHits
